// extracted by mini-css-extract-plugin
module.exports = {"trafficEchallan":"_3a3io","trafficEchallanCardWrapper":"_1Q-wd","trafficCardWrapper":"_2Izm7","trafficEchallanCard":"_1_moL"};